"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorAxiosMiddleware = exports.filterMap = exports.isJumpBBCLogin = exports.setCurrentDomainAppid = exports.noLoginJump = exports.setCurrentDomainLoginType = exports.getDomain = void 0;
var getUrlParam_1 = require("./getUrlParam");
var getGlobalWindow_1 = require("./getGlobalWindow");
var wd = (0, getGlobalWindow_1.getWindow)(); // 为了兼容next，window可能不存在
// 获取当前域名
var getDomain = function () {
    return wd.location.hostname;
};
exports.getDomain = getDomain;
var domainAndLoginTypeMap = {
    'outydm.healthjd.com': 16,
    'outydim.healthjd.com': 16,
    'outmxm.healthjd.com': 16,
    'outmxim.healthjd.com': 16,
    'outim.healthjd.com': 16,
    'outm.healthjd.com': 16,
};
var _a = (0, getUrlParam_1.getUrlParam)(), _b = _a.bbcShopId, bbcShopId = _b === void 0 ? '' : _b, _c = _a.enterpriseId, enterpriseId = _c === void 0 ? '' : _c, _d = _a.channelId, channelId = _d === void 0 ? '' : _d;
// https://jqk.jd.com/mid-login?enterpriseId=&bbcShopId=&channelId=&returnurl=https%3A%2F%2Flaputa-auto-yf.healthjd.com%2FexternalCompany%2FgameList%2Findex
var currentHref = wd && wd.location && wd.location.href ? wd.location.href : '';
var noLoginJumpMap = {
    'outm.healthjd.com': {
        type: 'jump',
        url: "https://jqk.jd.com/mid-login?enterpriseId=".concat(enterpriseId, "&bbcShopId=").concat(bbcShopId, "&channelId=").concat(channelId, "&returnurl=").concat(encodeURIComponent(currentHref))
    },
    'outim.healthjd.com': {
        type: 'jump',
        url: "https://jqk.jd.com/mid-login?enterpriseId=".concat(enterpriseId, "&bbcShopId=").concat(bbcShopId, "&channelId=").concat(channelId, "&returnurl=").concat(encodeURIComponent(currentHref))
    },
    'outydm.healthjd.com': {
        type: 'jump',
        url: "https://jqk.jd.com/mid-login?enterpriseId=".concat(enterpriseId, "&bbcShopId=").concat(bbcShopId, "&channelId=").concat(channelId, "&returnurl=").concat(encodeURIComponent(currentHref))
    },
    'outydim.healthjd.com': {
        type: 'jump',
        url: "https://jqk.jd.com/mid-login?enterpriseId=".concat(enterpriseId, "&bbcShopId=").concat(bbcShopId, "&channelId=").concat(channelId, "&returnurl=").concat(encodeURIComponent(currentHref))
    },
    'outmxm.healthjd.com': {
        type: 'toast',
    },
    'outmxim.healthjd.com': {
        type: 'toast',
    },
};
var domainAppidMap = {
    'outydm.healthjd.com': 'jd_nethp_patientout',
    'outydim.healthjd.com': 'jd_nethp_patientout',
    'outmxm.healthjd.com': 'jd_nethp_patientout',
    'outmxim.healthjd.com': 'jd_nethp_patientout',
    'outm.healthjd.com': 'jd_nethp_patientout',
    'outim.healthjd.com': 'jd_nethp_patientout',
};
/**
 *  修改指定域名对应的登录类型,如果不指定域名，使用默认配置
 *
 *  domain： 当前的域名 可选参数
 *  loginType：当前域名要修改的登录类型 可选参数
 *  axiosConfig： 当前color接口的请求体， data层 必须参数
 */
var setCurrentDomainLoginType = function (_a) {
    var domain = _a.domain, loginType = _a.loginType, axiosConfig = _a.axiosConfig;
    if (!axiosConfig) {
        console.error("🚀 ~ 入参丢失:", axiosConfig);
        return;
    }
    console.log("🚀 ~ setCurrentDomainLoginType ~ loginType:", loginType);
    if ((0, exports.getDomain)() === domain) {
        axiosConfig.loginType = loginType || 16;
        return;
    }
    // 如果没有指定domain，就使用默认配置
    if (domainAndLoginTypeMap[(0, exports.getDomain)()]) {
        axiosConfig.loginType = domainAndLoginTypeMap[(0, exports.getDomain)()];
    }
};
exports.setCurrentDomainLoginType = setCurrentDomainLoginType;
/**
 * 未登录情况跳转 镁信跳转到镁信的错误页面，英大跳转到英大对应的错误页面
 *  domain： 当前的域名 可选参数
 *  jumpUrl：当前域名未登录需要跳转的页面
 *  defaultLoginFunc: 原始项目中默认跳转方法
 *  toastFunc：当前域名无登录情况下需要弹窗处理，需要传入弹窗方法
 */
var noLoginJump = function (_a) {
    var domain = _a.domain, jumpUrl = _a.jumpUrl, defaultLoginFunc = _a.defaultLoginFunc, toastFunc = _a.toastFunc;
    if ((0, exports.getDomain)() === domain && jumpUrl) {
        wd.location.href = jumpUrl;
        return;
    }
    /**
     * 'outydm.healthjd.com': {
      type: 'jump',
      url: 'www.baidu.com'
    },
    'outydim.healthjd.com': {
      type: 'jump',
      url: 'www.baidu.com'
    },
    'outmxm.healthjd.com': {
      type: 'toast',
    },
    'outmxim.healthjd.com': {
      type: 'toast',
    },
     */
    var domainConfig = noLoginJumpMap[(0, exports.getDomain)()];
    if (domainConfig) {
        if (domainConfig.type === 'jump') {
            wd.location.href = domainConfig.url || jumpUrl;
        }
        else {
            toastFunc && toastFunc();
        }
    }
    else {
        defaultLoginFunc && defaultLoginFunc();
    }
};
exports.noLoginJump = noLoginJump;
/**
 * 设置对应域名下的请求appid
 * domain : 域名
 * appid ： appid
 * axiosConfig： axios请求体
 */
var setCurrentDomainAppid = function (_a) {
    var domain = _a.domain, appid = _a.appid, axiosConfig = _a.axiosConfig;
    if (!axiosConfig) {
        console.error("🚀 ~ setCurrentDomainAppid入参丢失:", axiosConfig);
        return;
    }
    console.log("🚀 ~ setCurrentDomainAppid ~ loginType:", appid);
    if ((0, exports.getDomain)() === domain) {
        axiosConfig.appid = appid || 'jd_nethp_patient_h5';
        return;
    }
    // 如果没有指定domain，就使用默认配置
    if (domainAppidMap[(0, exports.getDomain)()]) {
        axiosConfig.appid = domainAppidMap[(0, exports.getDomain)()];
    }
};
exports.setCurrentDomainAppid = setCurrentDomainAppid;
// 判断是否应该跳转到私域未登录页面
var isJumpBBCLogin = function () {
    var res = {
        isGoBBCLogin: false,
        jumpFunc: exports.noLoginJump
    };
    if (noLoginJumpMap.hasOwnProperty((0, exports.getDomain)())) {
        res.isGoBBCLogin = true;
    }
    return res;
};
exports.isJumpBBCLogin = isJumpBBCLogin;
// 将map中指定属性去除，返回一个新的map
var filterMap = function (mapObj, filterList) {
    if (mapObj === void 0) { mapObj = {}; }
    if (filterList === void 0) { filterList = []; }
    console.log('=======filterMap', mapObj, filterList);
    var resObj = {};
    for (var key in mapObj) {
        if (!filterList.includes(key)) {
            resObj[key] = mapObj[key];
        }
    }
    return resObj;
};
exports.filterMap = filterMap;
/**
 *
 * 此方法已经废弃⚠️，有风险请勿以npm方式引用
 * @desc: 无感登录切换appid和loginType 中间件
 * @param axiosObj axios实例
 * 重要： 因为axios请求拦截器是后注册先执行，所以必须保证这个请求拦截器第一个执行，也就是最先注册
 */
var useColorAxiosMiddleware = function (axiosObj) {
    // 添加请求拦截器
    axiosObj && axiosObj.interceptors.request.use(function (config) {
        var method = config.method, _a = config.baseURL, baseURL = _a === void 0 ? '' : _a;
        // console.log('进入执行体前置判断=====', baseURL, baseURL.includes("uploadImage") )
        // 排除上传图片的参数处理，图片上传单独处理
        if (!baseURL || !baseURL.includes("uploadImage")) {
            console.log('进入执行体判断');
            // GET请求参数处理
            if (method && method.toUpperCase() === "GET") {
                (0, exports.setCurrentDomainAppid)({ axiosConfig: config.params });
                (0, exports.setCurrentDomainLoginType)({ axiosConfig: config.params });
            }
            // POST请求参数处理
            if (method && method.toUpperCase() === "POST") {
                console.log('执行到=========');
                (0, exports.setCurrentDomainAppid)({ axiosConfig: config.data });
                (0, exports.setCurrentDomainLoginType)({ axiosConfig: config.data });
            }
        }
        return config;
    });
    // axiosObj && axiosObj.interceptors.response.use(response => {
    //   const toLoginCode = '1023';
    //   if () {
    //   }
    //   noLoginJump();
    //   return response;
    // });
};
exports.useColorAxiosMiddleware = useColorAxiosMiddleware;
